class NewsStreamUseCase {
    constructor(streamRepo) {
        this.streamRepo = streamRepo;
    }
    streamQuote(reqType, subscribe, callBack) {
        this.streamRepo.streamQuote(reqType, subscribe, callBack);
    }
}
export default NewsStreamUseCase;
